import { render, staticRenderFns } from "./Qrpay.vue?vue&type=template&id=0bedcb0e&scoped=true&"
import script from "./Qrpay.vue?vue&type=script&lang=js&"
export * from "./Qrpay.vue?vue&type=script&lang=js&"
import style0 from "../../../../../src/assets/css/shop-console.css?vue&type=style&index=0&id=0bedcb0e&scoped=true&lang=css&"
import style1 from "./Qrpay.vue?vue&type=style&index=1&id=0bedcb0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bedcb0e",
  null
  
)

export default component.exports